import { render, staticRenderFns } from "./SecureDocumentUploadComponent.vue?vue&type=template&id=6161cb48&scoped=true"
import script from "./SecureDocumentUploadComponent.vue?vue&type=script&lang=ts"
export * from "./SecureDocumentUploadComponent.vue?vue&type=script&lang=ts"
import style0 from "./SecureDocumentUploadComponent.vue?vue&type=style&index=0&id=6161cb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6161cb48",
  null
  
)

export default component.exports